/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateOrderOptions,
  CreateOrderStatus201,
  CreateOrderStatus400,
  CreateOrderStatus401,
  CreateOrderStatus403,
  CreateOrderStatus500,
} from '../types/CreateOrder'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createOrder } from '../clients/createOrder'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createOrderMutationKey = () => [{ url: '/v1/orders' }] as const

export function createOrderMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createOrderMutationKey()
  return mutationOptions<
    CreateOrderStatus201,
    ResponseErrorConfig<
      CreateOrderStatus400 | CreateOrderStatus401 | CreateOrderStatus403 | CreateOrderStatus500
    >,
    CreateOrderOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createOrder({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create a new order
 * {@link /v1/orders}
 */
export function useCreateOrder<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateOrderStatus201,
      ResponseErrorConfig<
        CreateOrderStatus400 | CreateOrderStatus401 | CreateOrderStatus403 | CreateOrderStatus500
      >,
      CreateOrderOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createOrderMutationKey()

  const baseOptions = createOrderMutationOptions(config) as UseMutationOptions<
    CreateOrderStatus201,
    ResponseErrorConfig<
      CreateOrderStatus400 | CreateOrderStatus401 | CreateOrderStatus403 | CreateOrderStatus500
    >,
    CreateOrderOptions,
    TContext
  >

  return useMutation<
    CreateOrderStatus201,
    ResponseErrorConfig<
      CreateOrderStatus400 | CreateOrderStatus401 | CreateOrderStatus403 | CreateOrderStatus500
    >,
    CreateOrderOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateOrderStatus201,
    ResponseErrorConfig<
      CreateOrderStatus400 | CreateOrderStatus401 | CreateOrderStatus403 | CreateOrderStatus500
    >,
    CreateOrderOptions,
    TContext
  >
}
